import React from 'react';

import { viewTypes }  from './view-types.js';
import CalendarHeader from './calendar-header.jsx';

class DateView extends React.Component {
    touchStartLocation = { x: 0, y: 0 };

    state = {
        focus: false,
        focusRow: 0,
        focusCol: 0,
        srDate: this.props.ariaLabels.instructions
    };

    render() {
        const {
            year,
            month,
            ariaLabels
        } = this.props;

        const daysOfWeek = this.getDaysOfWeek();
        const daysOfWeekClassNames = [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat' ];

        const weeksAndDays = this.getWeeksAndDays( year || 1900, month || 0 );

        const yearMonth = new Date( year, month, 1, 0, 0, 0, 0 );
        const yearMonthText = this.getYearMonthText( yearMonth );

        const nextYearMonth = new Date( yearMonth.getTime() );
        nextYearMonth.setMonth( nextYearMonth.getMonth() + 1 );

        const previousYearMonth = new Date( yearMonth.getTime() );
        previousYearMonth.setMonth( previousYearMonth.getMonth() - 1 );

        return (
            <div aria-label={ ariaLabels.title } className="date-view"
                onTouchStart={ this.handleTouchStart } onTouchMove={ this.handleTouchMove } >

                <CalendarHeader text={ yearMonthText } onDrill={ this.handleDrill }
                    onPrevious={ this.handlePrev } previousText={ ariaLabels.prevMonth }
                    onNext={ this.handleNext } nextText={ ariaLabels.nextMonth } />

                <div>
                    <input onFocus={ this.handleInputFocus } onBlur={ this.handleInputBlur } readOnly={ true }
                        onKeyDown={ this.handleInputKeyDown } value={ this.state.srDate } className="sr-only" />

                    <table>
                        <thead>
                            <tr className="week" aria-hidden={ true } >
                            {
                                    daysOfWeek.map( ( dayOfWeek, index ) => {
                                        return (
                                            <th key={ dayOfWeek } className={ 'day-of-week ' + daysOfWeekClassNames[ index ] }>
                                                {dayOfWeek}
                                            </th>
                                        );
                                    } )
                            }
                            </tr>
                        </thead>
                        <tbody>
                        {
                            weeksAndDays.map( ( week, index ) => {
                                return <tr key={ index } className="week">
                                    {
                                        week.map( ( day ) => {
                                            return <td key={ day.number } role="link" className={
                                                    'day ' + daysOfWeekClassNames[ day.dayOfWeek ] +
                                                    ( day.inMonth ? '' : ' not-in-month' ) +
                                                    ( day.today ? ' today' : '' ) +
                                                    ( day.range ? ' range' : '' ) +
                                                    ( day.from ? ' range-from' : '' ) +
                                                    ( day.to ? ' range-to' : '' ) +
                                                    ( day.selected ? ' selected' : '' ) +
                                                    ( day.focus ? ' focus' : '' )
                                                } onClick={ () => { this.selectDate( day.date ); } }>
                                                    <span>{day.number}</span>
                                                    { day.hasActivity && <span className="activity" /> }
                                                </td>;
                                        } )
                                    }
                                </tr>;
                            } )
                        }
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }

    getDaysOfWeek = () => {
        const daysOfWeek = [];

        const date = new Date();
        date.setDate( date.getDate() - date.getDay() );

        for ( let i = 0; i < 7; i++ ) {
            daysOfWeek.push( this.getDayOfWeekText( date ) );

            date.setDate( date.getDate() + 1 );
        }

        return daysOfWeek;
    };

    getWeeksAndDays = ( year, month ) => {
        const days = [];

        let todayValue = new Date();
        todayValue = new Date( todayValue.getFullYear(), todayValue.getMonth(), todayValue.getDate(), 0, 0, 0, 0 ).valueOf();

        let selectedValue = this.props.value;
        selectedValue = ( selectedValue ? new Date( selectedValue.getFullYear(), selectedValue.getMonth(), selectedValue.getDate(), 0, 0, 0, 0 ).valueOf() : null );

        const firstDate = new Date( year, month, 1, 0, 0, 0, 0 );

        const lastDate = new Date( ( month === 11 ? year + 1 : year ), ( month === 11 ? 0 : month + 1 ), 1, 0, 0, 0 );
        lastDate.setDate( lastDate.getDate() - 1 );

        const date = new Date( firstDate.valueOf() );
        date.setDate( date.getDate() - date.getDay() );

        let fromValue = ( ( this.props.fromValue instanceof Date ) ? this.props.fromValue : null );
        fromValue = ( fromValue ? new Date( fromValue.getFullYear(), fromValue.getMonth(), fromValue.getDate(), 0, 0, 0, 0 ).valueOf() : null );

        let toValue = ( ( this.props.toValue instanceof Date ) ? this.props.toValue : null );
        toValue = ( toValue ? new Date( toValue.getFullYear(), toValue.getMonth(), toValue.getDate(), 0, 0, 0, 0 ).valueOf() : null );

        if ( fromValue && !toValue ) {
            toValue = selectedValue;
        } else if ( toValue && !fromValue ) {
            fromValue = selectedValue;
        }

        this.selectedRow = 0;
        this.selectedCol = 0;

        for ( let i = 0; i < 42; i++ ) {
            const week = parseInt( Math.floor( i / 7 ) );

            if ( !days[ week ] ) {
                days[ week ] = [];
            }

            const dateValue = date.valueOf();

            days[ week ].push( {
                number: date.getDate(),
                date: new Date( dateValue ),
                dayOfWeek: i % 7,
                inMonth: ( date >= firstDate && date <= lastDate ),
                today: ( dateValue === todayValue ),
                selected: ( dateValue === selectedValue ),
                to: ( dateValue === toValue ),
                from: ( dateValue === fromValue ),
                range: ( selectedValue && dateValue >= fromValue && dateValue <= toValue ),
                focus: ( this.state.focus && this.state.focusRow === week && this.state.focusCol === ( i % 7 ) ),
                hasActivity: ( typeof this.props.hasActivity === 'function' && this.props.hasActivity(
                    new Date( dateValue ), new Date( dateValue + ( 1000 * 60 * 60 * 24 ) - 1 ) ) )
            } );

            if ( dateValue === selectedValue ||
                ( !this.props.value && dateValue === toValue ) ||
                ( !this.props.value && dateValue === fromValue ) ||
                ( !this.props.value && !this.props.toValue && !this.props.fromValue && dateValue === todayValue ) ) {
                this.selectedRow = week;
                this.selectedCol = ( i % 7 );
            }

            date.setDate( date.getDate() + 1 );
        }

        return days;
    };

    handleInputFocus = () => {
        this.setState( {
            focus: true,
            focusRow: this.selectedRow,
            focusCol: this.selectedCol
        } );
    };

    handleInputBlur = () => {
        this.setState( {
            focus: false
        } );
    };

    handleInputKeyDown = ( e ) => {
        let {
            focusRow,
            focusCol
        } = this.state;

        const getDate = () => {
            const firstDate = new Date( this.props.year, this.props.month, 1, 0, 0, 0, 0 );
            const date = new Date( firstDate.valueOf() );

            date.setDate( date.getDate() - date.getDay() + ( ( focusRow * 7 ) + focusCol ) );
            return date;
        };
        // formatting options for screen readers
        const dateFormatOpts = { year: 'numeric', month: 'long', day: 'numeric' };

        switch ( e.keyCode ) {
            case 38: //up arrow
                focusRow = focusRow - 1;
                if ( focusRow < 0 ) { focusRow = 5; }

                this.setState( { focusRow: focusRow } );
                break;

            case 40: //down arrow
                focusRow = focusRow + 1;
                if ( focusRow > 5 ) { focusRow = 0; }

                this.setState( { focusRow: focusRow } );
                break;

            case 37: //left arrow
                focusCol = focusCol - 1;
                if ( focusCol < 0 ) { focusCol = 6; }

                this.setState( { focusCol: focusCol } );
                break;

            case 39: //right arrow
                focusCol = focusCol + 1;
                if ( focusCol > 6 ) { focusCol = 0; }

                this.setState( { focusCol: focusCol } );
                break;

            case 13: //enter
                this.selectDate( getDate() );
                break;

            default:
                break;
        }

        this.setState( {
            srDate: new Intl.DateTimeFormat( this.props.locale, dateFormatOpts ).format( getDate() )
        } );
    };

    handleTouchStart = ( e ) => {
        this.touchStartLocation = { x: e.touches[ 0 ].clientX, y: e.touches[ 0 ].clientY };
    };

    handleTouchMove = ( e ) => {
        const xDiff = e.touches[ 0 ].clientX - this.touchStartLocation.x;
        const yDiff = e.touches[ 0 ].clientY - this.touchStartLocation.y;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
            if ( xDiff > 0 ) {
                this.handlePrev();
            } else {
                this.handleNext();
            }
        }
    };

    handleDrill = () => {
        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.month, this.props.year, this.props.month );
        }

        this.setState( { focusDate: null } );
    };

    handlePrev = () => {
        let {
            year,
            month,
         } = this.props;

        if ( month === 0 ) {
            month = 11;
            year = year - 1;
        } else {
            month = month - 1;
        }

        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.date, year, month );
        }

        this.setState( { focusDate: null } );
    };

    handleNext = () => {
        let {
            year,
            month,
         } = this.props;

        if ( month === 11 ) {
            month = 0;
            year = year + 1;
        } else {
            month = month + 1;
        }

        if ( typeof this.props.onViewChange === 'function' ) {
            this.props.onViewChange( viewTypes.date, year, month );
        }

        this.setState( { focusDate: null } );
    };

    selectDate = ( date ) => {
        if ( this.props.toValue && date > this.props.toValue &&
            typeof this.props.onToChange === 'function' ) {
            this.props.onToChange( date );
        }

        if ( this.props.fromValue && date < this.props.fromValue &&
            typeof this.props.onFromChange === 'function' ) {
            this.props.onFromChange( date );
        }

        if ( typeof this.props.onChange === 'function' ) {
            this.props.onChange( date );
        }

        this.setState( { focusDate: null } );
    };

    getYearMonthText = ( date ) => {
        const locale = this.props.locale;

        return new Intl.DateTimeFormat( locale, { month: 'long' } ).format( date ) +
            ' ' + new Intl.DateTimeFormat( locale, { year: 'numeric' } ).format( date );
    };

    getDayOfWeekText = ( date ) => {
        return new Intl.DateTimeFormat( this.props.locale, { weekday: 'short' } ).format( date );
    };
}

export default DateView;
